'use client';

import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import DiscountSVG from '@/public/icon/discount.svg';
import DiscountSchedule from '@/types/discountSchedule';
import { DateHelper } from '@/utils/helpers/DateHelper';
import Routes from '@/utils/routes';

interface PlacePageScheduleCountDownProps {
  scheduleDay: DiscountSchedule;
  place: any;
}

export default function PlacePageScheduleCountDown({
  scheduleDay,
  place,
}: PlacePageScheduleCountDownProps) {
  // States
  const [timeRemaining, setTimeRemaining] = useState<
    | {
        hours: number;
        minutes: number;
        seconds: number;
      }
    | false
  >(false);

  const t = useTranslations('Pages.Place.HappyHour');

  useEffect(() => {
    const updateCountdown = () => {
      const remaining = DateHelper.getTimeRemaining(
        scheduleDay.todayStartTime || scheduleDay.startTime,
        scheduleDay.todayEndTime || scheduleDay.endTime
      );
      setTimeRemaining(remaining);
      if (!remaining && intervalId) clearInterval(intervalId);
    };
    const intervalId = setInterval(updateCountdown, 1000);
    updateCountdown();
    return () => clearInterval(intervalId);
  }, [scheduleDay]);

  if (!timeRemaining) return null;

  return (
    <Link
      href={Routes.PlaceMenu(place.id)}
      className=' relative z-10 mx-3 md:mx-0 mt-3 flex items-center justify-between rounded-md border border-out-light-green bg-out-light-green-faded p-4'
    >
      <div className='flex items-center space-x-4'>
        <DiscountSVG />
        <div className='space-y-1'>
          <p className='font-semibold text-[#E6FB9B]'>
            {t('currentlyInHappyHour')}
          </p>
          <p className='text-sm font-medium text-[#9DD111]'>
            {t.rich('remainingTime', {
              timeRemainingHours: timeRemaining.hours,
              timeRemainingMinutes: timeRemaining.minutes || 1,
            })}
          </p>
        </div>
      </div>
      <ChevronRightIcon className='size-5 stroke-2 text-out-light-green' />
    </Link>
  );
}
